import { useEffect, useState } from "react";
import { AddUpdateCart, GetCart } from '../../Utility/CartUtility';
import { parse } from "path";
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../Utility/UserUtility';

const Cart = () => {

    const navigate = useNavigate();

    const [CartDetails, setCartDetails] = useState<any[]>([]);
    const [TotalAmount, setTotalAmount] = useState(0);


    useEffect(function () {
        setCartDetails(GetCart());
        getTotal(GetCart());
        scrollToTop();
    }, [])

    function scrollToTop() {
        window.scrollTo(0, 0);
    }
    const deleteCartItem = (_Item_Id: any) => {

        const response = AddUpdateCart('Delete', _Item_Id, null, 0, 0, 0, null, null);
        $("#CartText").text(GetCart().length);
        setCartDetails(GetCart());
        getTotal(GetCart());
    }

    const QuantityUpdate = (Type: any, Item_Id: any, Index: any) => {

        let Qty = 0


        if (Type === 'Add') {
            Qty = parseInt(CartDetails[Index].Quantity) + 1;
            AddUpdateCart('Update', Item_Id, null, Qty, null, null, Index, null);
        }
        else if (Type === 'Sub' && parseInt(CartDetails[Index]?.Quantity) > 1) {
            Qty = parseInt(CartDetails[Index].Quantity) - 1;
            AddUpdateCart('Update', Item_Id, null, Qty, null, null, Index, null);
        }

        setCartDetails(GetCart());
        getTotal(GetCart());

    }

    const getTotal = (itemList: any) => {

        let total: number = 0;

        itemList?.map((item: any, index: any) => {
            total = total + (item?.Seller_Price * item?.Quantity);
        });

        setTotalAmount(total);
    }

    const handleProceedToCheckout = () => {

        let userDetails = getUserDetails();

        if (userDetails === undefined || userDetails === null) {
            $('#btnLogin').click();
        }
        else {
            navigate('/PlaceOrder');
        }


    }

 


    return (
        <>
            <div className=" breadcrumb-padding-180"></div>
            {/* <!-- Breadcumb Section Start --> */}
            <div className="bar">
                <div className="mainWrapper">
                    <div className="statusBar">
                        <span className="pBar"></span>
                        <div className="node n0 done nConfirm0">
                            <div className="main done m0 done nConfirm0">1</div>
                            <span className="text t0 done nConfirm0">Add to Cart</span>
                        </div>
                        <div className="node n1 nConfirm1">
                            <div className="main m1 nConfirm1">2</div>
                            <span className="text t1 nConfirm1">Shipping Details</span>
                        </div>
                        <div className="node n2 nConfirm2">
                            <div className="main m2 nConfirm2">3</div>
                            <span className="text t2 nConfirm2">Make Payment</span>
                        </div>

                    </div>

                </div>
            </div>


            {/* <!-- Shop Cart Section Start --> */}
            <div className="cart-section section-padding">
                <div className="container">
                    <div className="main-cart-wrapper">
                        <div className="row g-5">
                            <div className="col-xl-12">

                                <div className="table-responsive m-hidden">
                                    <table className="table">
                                        <tbody>
                                            <tr className="border">
                                                <td>
                                                    {
                                                        CartDetails?.map((item: any, index: any) =>
                                                        (
                                                            <div className="cart-title">
                                                                <a onClick={() => deleteCartItem(item?.Item_Id)} className="remove-icon mremove-icon">
                                                                    <img src="assets/img/icon/icon-9.svg" alt="img" />
                                                                </a>

                                                                <div className="col-xl-12">
                                                                    <span className="d-flex gap-5 align-items-center">
                                                                        <span className="cart-title">
                                                                            <a href={"/" + item?.Item_Title_Url + "-" + item?.Item_Id}>   {item?.Item_Title}</a>
                                                                        </span>
                                                                    </span><br />
                                                                    <div>
                                                                        <span className="d-flex align-items-center">
                                                                            <span className="mcart-price">₹ {item?.Seller_Price}</span>
                                                                            <span className="quantity-basket">
                                                                                <span className="qty" style={{ margin: "0 10px" }}>
                                                                                    <button className="qtyminus" aria-hidden="true" onClick={() => { QuantityUpdate('Sub', item?.Item_Id, index) }} >−</button>
                                                                                    <input type="number" name="qty" id="qty2" min="1" max="10" step="1"
                                                                                        value={item?.Quantity} />
                                                                                    <button className="qtyplus" aria-hidden="true" onClick={() => { QuantityUpdate('Add', item?.Item_Id, index) }} >+</button>

                                                                                </span>
                                                                            </span>
                                                                            <span className="msubtotal-price"><b>₹ {(item?.Seller_Price * item?.Quantity)}</b></span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <hr></hr>
                                                            </div>

                                                        )

                                                        )
                                                    }

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="table-responsive desk-hidden">

                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th className="cart-border-none">Item Name</th>
                                                <th className="cart-border-none">Qty</th>
                                                <th className="cart-border-none">Price</th>
                                                <th className="cart-border-none">Total</th>
                                                <th className="cart-border-none"></th>
                                            </tr>
                                            <tr className="border-bottom"></tr>
                                        </thead>
                                        <tbody>
                                            {
                                                CartDetails?.map((item: any, index: any) =>
                                                (
                                                    <tr>
                                                        <td className="cart-border-none">
                                                            <span className="d-flex gap-5 align-items-center">
                                                                <span className="cart-title">

                                                                    <a href={"/" + item?.Item_Title_Url + "-" + item?.Item_Id}>   {item?.Item_Title}</a>
                                                                </span>
                                                            </span>
                                                        </td>

                                                        <td className="cart-border-none">
                                                            <span className="quantity-basket">
                                                                <span className="qty">
                                                                { (item?.Quantity === 1) && <button className="qtyminus" aria-hidden="true" onClick={() => deleteCartItem(item?.Item_Id)} > <i className='fas fa-trash-alt' style={{fontSize:"16px"}} ></i> </button> }
                                                                    { (item?.Quantity > 1) && <button className="qtyminus" aria-hidden="true" onClick={() => { QuantityUpdate('Sub', item?.Item_Id, index) }} >−</button> }
                                                                    <input type="number" name="qty" id="qty2" min="1" max="10" step="1"
                                                                        value={item?.Quantity} />
                                                                    <button className="qtyplus" aria-hidden="true" onClick={() => { QuantityUpdate('Add', item?.Item_Id, index) }} >+</button>
                                                                </span>
                                                            </span>
                                                        </td>
                                                        <td className="cart-border-none">
                                                            <span className="cart-price">₹ {item?.Seller_Price}</span>
                                                        </td>
                                                        <td className="cart-border-none">
                                                            <span className="d-flex gap-5 align-items-center">
                                                                <span className="subtotal-price">₹ {(item?.Seller_Price * item?.Quantity)}</span>
                                                            </span>
                                                        </td>

                                                        <td className="cart-border-none">
                                                            <span className="d-flex gap-5 align-items-center">
                                                                <a onClick={() => deleteCartItem(item?.Item_Id)} className="remove-icon">
                                                                    <img src="assets/img/icon/icon-9.svg" alt="img" />
                                                                </a>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                )

                                                )
                                            }

                                            {((CartDetails === undefined || CartDetails === null || CartDetails.length === 0)) &&
                                                (
                                                    <>
                                                        <tr>
                                                            <td colSpan={5}>No Item added in cart</td>
                                                        </tr>
                                                    </>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    <div className="border"></div>
                                </div>

                            </div>

                            {
                                ((CartDetails !== undefined && CartDetails !== null && CartDetails?.length > 0)) &&
                                (
                                    <>
                                        <div className="col-xl-7"></div>
                                        <div className="col-xl-5">
                                            <div className="checkout-order-area">
                                                <h3>Order Summery</h3>
                                                <div className="product-checout-area">

                                                    <div className="checkout-item d-flex align-items-center justify-content-between">
                                                        <p>Total Payment:</p>
                                                        <p>₹ {TotalAmount}</p>
                                                    </div>
                                                    <center> <a onClick={handleProceedToCheckout} className="theme-btn btnpnk">Proceed to checkout</a></center>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            }

                            {((CartDetails === undefined || CartDetails === null || CartDetails.length === 0)) &&
                                (
                                    <>
                                        <div className="col-xl-8"></div>
                                        <div className="col-xl-4">
                                            <div className="checkout-order-area">
                                                <center> <a href="/" className="theme-btn btnpnk">Continue Shopping</a></center>
                                            </div>
                                        </div>

                                    </>
                                )
                            }


                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
export default Cart;